function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.6445 11.8074L4.12073 11.5266L3.99336 10.9886C3.94931 10.8025 3.92582 10.6078 3.92582 10.4066C3.92582 9.0183 5.05126 7.89286 6.43956 7.89286C6.64372 7.89286 6.84124 7.91704 7.0298 7.96236L7.60432 8.10045L7.87303 7.57421C8.72985 5.89625 10.4735 4.75 12.4835 4.75C15.1017 4.75 17.2666 6.6957 17.6093 9.21975L17.6868 9.79097L18.2588 9.86299C20.5091 10.1463 22.25 12.0682 22.25 14.3956C22.25 16.9188 20.2045 18.9643 17.6813 18.9643H5.59341C3.47075 18.9643 1.75 17.2435 1.75 15.1209C1.75 13.7107 2.50907 12.477 3.6445 11.8074Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgCloud = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cloud.1d87e9df.svg";
export { ForwardRef as ReactComponent };